import { useQuery } from '@tanstack/react-query';

export function useRepairsQuery(api, orgId, authToken) {
  return useQuery({
    queryKey: ['repairs', orgId],
    queryFn:  () => api.repairs.getAll(orgId, authToken),
    enabled:  Boolean(api && orgId && authToken),
  });
}
